/**
 * VAT is always surfaced as the dedicated "Includes X% VAT" line, never as a generic row in the
 * additional-taxes list. The backend stores the full `finalTaxList` *with* VAT kept (data
 * completeness — see hotels-service `vat-summary.ts`), so every DISPLAY site must filter VAT out or
 * it double-counts (the VAT line + a "VAT" tax row). This is the single shared predicate for that.
 */

/** True when a tax entry is a VAT line (case-insensitive, trimmed). */
export function isVatTax(t: { name?: unknown } | null | undefined): boolean {
  return typeof t?.name === 'string' && t.name.trim().toLowerCase() === 'vat';
}

/** Drop VAT-named tax entries for display. Mirrors the backend `vat-summary.excludeVatTaxes`. */
export function excludeVatTaxes<T extends { name?: unknown }>(list: T[] | undefined | null): T[] {
  return (Array.isArray(list) ? list : []).filter((t) => !isVatTax(t));
}
